/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { ListCell, Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { capitalize } from 'lodash';
import { useLabel } from '@/wpt-lib/pdf/useData';

const CourseworkSupervision = ({
    projectType,
    session = {},
    expectedNumberOfStudentCourseWork = {},
    courseworkProjectCreditPoints,
    courseworkProjectSupervisionProjectDetails,
}: Partial<{
    projectType: string;
    session: { [session: string]: boolean };
    expectedNumberOfStudentCourseWork: { [student: string]: number };
    courseworkProjectCreditPoints: string;
    courseworkProjectSupervisionProjectDetails: string;
}>) => (
    <>
        <Row widths={courseworkProjectCreditPoints ? [23, 23, 34, 23] : undefined}>
            <ValueCell label="Project Type" value={useLabel('projectType', projectType ?? '')} />
            <ListCell
                label="Session"
                values={Object.entries(session)
                    .filter(([, t]) => t)
                    .map(([s]) => capitalize(s))}
            />
            <ListCell
                label="Estimated Planned time for this activity"
                values={Object.entries(expectedNumberOfStudentCourseWork).map(
                    ([student, num]) => `${capitalize(student)} - ${num}`,
                )}
            />
            {courseworkProjectCreditPoints && (
                <ValueCell label="Number of credit points" value={courseworkProjectCreditPoints} />
            )}
        </Row>
        {courseworkProjectSupervisionProjectDetails && (
            <Row>
                <ValueCell label="Project Details" value={courseworkProjectSupervisionProjectDetails} />
            </Row>
        )}
    </>
);

export default CourseworkSupervision;
